module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sert"
  }, [_vm._v("“Fear not, I am the first and the last, and the living one…")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("and I have the keys to Death and Hades. Now write what you see,")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("what is and what is to take place hereafter….")]), _vm._v(" "), _c('p', {
    staticClass: "ser2"
  }, [_vm._v("“To him who conquers I will give some of the hidden manna,")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("and I will give him a white stone, with a new name written on the stone")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("which no one knows except him who receives it.")]), _vm._v(" "), _c('p', {
    staticClass: "ser2"
  }, [_vm._v("“Therefore I counsel you to buy from me gold refined by fire,")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("that you may be rich, and white garments to clothe you….”")]), _vm._v(" "), _c('p', {
    staticClass: "ser2"
  }, [_vm._v("Revelation 1:17-19; 2:17; 3:18, RSV")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5963829a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hell_and_Beyond_Split5.vue
// module id = 69
// module chunks = 0